import React from 'react';
import styled from 'styled-components';
import Header from './header';
import Footer from './footer';

const LayoutWrapper = styled.div`
  width: 100%;
  margin: 0;
  padding-top: 85px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  min-height: 100vh;

  @media (max-width: 768px) {
    padding-top: 72px;
  }
`;

const MainContent = styled.main`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 100%;
  overflow-x: hidden;
`;

const Layout = ({ children }) => {
  return (
    <LayoutWrapper>
      <Header />
      <MainContent>
        {children}
      </MainContent>
      <Footer />
    </LayoutWrapper>
  );
};

export default Layout;
